<template>
    <q-form @submit="this.onSubmit" class="ms-form ms-form--narrow">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomSelect
          :options="this.floorOptions"
          label="Начальный этаж"
          optionValueKey="floor"
          optionLabelKey="floor"
          :value="this.formData.begin_floor"
          @change="(value) => onChange('begin_floor', value)"
        />
        <CustomSelect
          :options="this.floorOptions"
          label="Конечный этаж"
          optionValueKey="floor"
          optionLabelKey="floor"
          :value="this.formData.end_floor"
          @change="(value) => onChange('end_floor', value)"
          :error="validationError"
          :error-message="errorMessage"
        />
      </div>
      <CustomModalFooter :btn-loading="this.loading" :disable-submit="validationError" />
    </q-form>
  </template>
  <script>
  import CustomModalFooter from "@/components/modal/modals/modal-footer";
  import CustomSelect from "@/components/form/CustomSelect";
  import { getFloorOptions } from "@/components/modal/modals/flat-common-area-upd/services.js";
  
  export default {
    name: "flat-clone",
    components: { CustomSelect, CustomModalFooter },
    props: ["data"],
    data() {
      return {
        floorOptions: [],
        loading: false,
        steps: [],
        resident_id: this.data?.resident_id || "",
        entrance: this.data?.body?.entrance || "",
        validationError: false,
        errorMessage: "",
        formData: {
          flat_id: this.data?.body?.flat_id || "",
          begin_floor: "",
          end_floor: "",
        },
      };
    },
    methods: {
      async onChange(key, value) {
        this.formData[key] = value;
        this.validateFloors();
      },
      
      validateFloors() {
        if (this.formData.begin_floor && this.formData.end_floor) {
          const beginFloor = Number(this.formData.begin_floor);
          const endFloor = Number(this.formData.end_floor);
          
          if (endFloor < beginFloor) {
            this.validationError = true;
            this.errorMessage = "Конечный этаж должен быть больше начального";
            return false;
          }
        }
        
        this.validationError = false;
        this.errorMessage = "";
        return true;
      },
      async onSubmit() {
        if (!this.validateFloors()) {
          return;
        }
        
        this.loading = true;
        this.formData.begin_floor = Number(this.formData.begin_floor);
        this.formData.end_floor = Number(this.formData.end_floor);
        await this.data?.onSubmit(this.formData);
        this.loading = false;
      },
      async getFloors() {
        const body = {
          resident_id: this.resident_id,
          entrance: this.entrance,
        };
        const res = await getFloorOptions(body);
        this.floorOptions = res || [];
      },
    },
    mounted() {
      this.getFloors();
    },
  };
  </script>
